<template>
<cotainer>
  <v-card persistent>
    <v-card-title class="primary white--text">
      <span class="headline">{{ formTitle }}</span>
      <v-spacer/>
        <!-- <router-link to="/products/true/invoice"> -->
          <v-btn outline  @click="$emit('addProduct')" class="white--text">
            <v-icon left dark>add</v-icon>
              NEW PRODUCT
          </v-btn>
        <!-- </router-link> -->
      <v-btn outline @click="scanItem()" class="white--text">
        <v-icon left dark>qr_code_scanner</v-icon>
          SCAN
      </v-btn>
      <v-btn outline @click="openProductReport()" class="white--text">
            SUGGESTIONS
        </v-btn>
    </v-card-title>
    <p
      style="
        font-size: 11px;
        font-style: italic;
        color: green;
        padding: 10px;
      "
      >
      **[<b>Escape</b> for Cancel],[<b>Enter</b> for SAVE] & [<b>Plus(+)</b> for SAVE & ADD].
    </p>

    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs11 style="margin-top: -35px;">
            <v-data-table :headers="getHeaders" :items="allItems" hide-actions class="elevation-1">
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.productName }}</td>
                <!-- <td v-if="gstInvoice" class="text-xs-left">{{ props.item.HSN_code }}</td> -->
                <!-- <td v-if="gstInvoice">{{ props.item.taxableGST_rate }}</td> -->
                <td>{{ props.item.unit }}</td>
                <td>{{ props.item.rate }}</td>
                <td>{{ props.item.quantity }}</td>
                <td>{{ props.item.basicPrice }}</td>
                <td v-if="gstInvoice">{{ props.item.GSTValue }}</td>
                <td>{{ props.item.specialCharge }}</td>
                <td>{{ props.item.tradeDiscount }}</td>
                
                <td>{{ props.item.totlePrice }}</td>
                <!-- <td v-if="gstInvoice">{{ props.item.CGST_val}} ₹ ({{props.item.CGST}} %)</td>
                <td v-if="gstInvoice">{{ props.item.SGST_val}} ₹ ({{props.item.SGST}} %)</td>
                <td v-if="gstInvoice">{{ props.item.IGST_val}} ₹ ({{props.item.IGST}} %)</td> -->
                <td class="justify-center layout px-0">
                  <v-btn icon class="mx-0" @click="editItem(props.item)">
                    <v-icon color="teal">edit</v-icon>
                  </v-btn>
                  <v-btn icon class="mx-0" @click="deleteItem(props.item)">
                    <v-icon color="pink">delete</v-icon>
                  </v-btn>
                </td>
              </template>
              <template slot="no-data">No Items</template>
            </v-data-table>
          </v-flex>

          <v-flex xs1 style="margin-top: -60px;">
            <v-btn class="cancel-btn-add-icons" color="blue darken-1" @click.native="close">Cancel</v-btn>
            <br/>
            <!-- <v-btn class="grey darken-1" @click.native="close">Back</v-btn>
            <br/> -->
            <v-btn class="primary white--text add-btn-add-icons" :disabled="!(item.productName && item.quantity && item.rate)" @click.native="save(false)">Save</v-btn>
            <br/>
            <v-btn class="add-save-btn-add-icons" color="success white--text" :disabled="!(item.productName && item.quantity && item.rate)" @click.native="save(true)">Save&Add</v-btn>
          </v-flex>

          <v-flex xs12 sm6 md6>
            <v-select
              v-model="item.productName"
              @change="productChange"
              :items="productsByBrand"
              class="add-product-dropdown"
              item-text="name"
              return-object
              autocomplete
              label="Products"
            />
          </v-flex>
          
          <!-- <v-flex xs12 sm1 md1>
            <v-text-field v-if="item.productName" type="number" :value="selectedProduct.quantity" :disabled="true" label="Available Quantity"></v-text-field>
          </v-flex> -->
          <!-- <v-flex xs12 sm6 md2>
            <v-text-field
              type="number"
              disabled
              v-if="item.productName"
              v-model.number="item.taxableGST_rate"
              suffix="%"
              label="GST"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field type="text" v-if="item.productName" disabled v-model.number="item.HSN_code" label="HSN Code"></v-text-field>
          </v-flex> -->
          <v-flex xs12 sm6 md2>
            <v-select 
              :items="availableProductUnit" label="Unit"  v-model="item.unit">
            </v-select>
          </v-flex>
          
          <v-flex xs12 sm6 md2>
            <v-text-field v-if="item.productName" type="number" v-model.number="item.quantity" label="Quantity"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field v-if="item.productName" type="number" v-model.number="item.rate" label="Product Rate"></v-text-field>
          </v-flex>
            <v-flex xs12 sm2 md2  v-if="item.productName && item.quantity && item.rate">
              <v-text-field
              type="number"
              v-model.number="item.grossWeight"
              label="Gross Weight"
              :suffix="item.unit"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm1 md1  v-if="item.productName && item.quantity && item.rate">
            <v-text-field
              type="number"
              v-model="item.purity"
              label="Purity"
              suffix="%"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm2 md2 v-if="item.productName && item.quantity && item.rate">
            <v-text-field
              type="number"
              v-model.number="item.netWeight"
              disabled
              label="Net Weight"
              :suffix="item.unit"
            ></v-text-field>
          </v-flex>
           <!-- <v-flex xs12 sm6 md4  v-if="item.productName && item.quantity && item.rate">
            <v-text-field
              type="text"
              v-model="item.tunch"
              label="Tunch"
            ></v-text-field>
          </v-flex> -->
          <v-flex xs12 sm2 md2>
            <v-text-field 
              v-if="item.productName && item.quantity && item.rate"
              type="number" 
              disabled 
              v-model.number="item.basicPrice" 
              label="Basic Price">
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm2 md2>
            <v-text-field
              v-if="item.productName && item.quantity && item.rate" 
              type="number" 
              disabled 
              v-model.number="item.GSTValue" 
              label="GST Value">
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm2 md2>
            <v-text-field
              v-if="item.productName && item.quantity && item.rate"
              type="number"
              disabled
              v-model.number="item.totlePrice"
              label="Total Price"
            ></v-text-field>
          </v-flex>

        
           <v-flex xs12 sm6 md4>
            <v-switch
              v-if="item.productName && item.quantity && item.rate" 
              v-model="isTradePercentage"
              :label="`Trade Discount in: ${isTradePercentage ? '%' : '₹'}`"
            ></v-switch>
          </v-flex>
           <v-flex xs12 sm6 md4>
            <v-text-field
              v-if="item.productName && item.quantity && item.rate && isTradePercentage" 
              type="number"
              @keyup="calculateTradeDiscount()" 
              suffix="%"
              v-model.number="tradeDiscountPercentage" 
              label="Trade Discount">
            </v-text-field>
          </v-flex>
           <v-flex xs12 sm6 md4>
            <v-text-field
              v-if="item.productName && item.quantity && item.rate" 
              type="number" 
              suffix="₹"
              :disabled="isTradePercentage"
              v-model.number="item.tradeDiscount"
              label="Trade Discount">
            </v-text-field>
          </v-flex>
          <v-flex xs2 v-if="firmSetting && firmSetting.individualProdBrokerage">
            <v-text-field
              type="Number"
              label="Brokerage Rate (in %)"
              v-model="item.brokerageRate"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs2 v-if="firmSetting && firmSetting.individualProdBrokerage">
            <v-text-field
              type="number"
              label="Brokerage Amount (in ₹)"
              disabled
              :value="
                Number.parseFloat(
                  (Number.parseFloat(item.totlePrice) *
                    item.brokerageRate) /
                    100
                ).toFixed(2)
              "
            >
            </v-text-field>
          </v-flex>

          <!-- Special Charge -->
           <v-flex xs12 sm6 md4>
             <v-switch
               v-if="item.productName && item.quantity && item.rate" 
               v-model="isSpecialChargePercentage"
               :label="`Labour Charge: ${isSpecialChargePercentage ? '%' : '₹'}`"
             ></v-switch>
           </v-flex>
           <v-flex xs12 sm6 md4>
             <v-text-field
               v-if="item.productName && item.quantity && item.rate && isSpecialChargePercentage" 
               type="number"
               @keyup="calculateSpecialCharge()" 
               suffix="%"
               v-model.number="specialChargePercentage" 
               label="Labour Charge in %">
             </v-text-field>
           </v-flex>
            <v-flex xs12 sm6 md4>
             <v-text-field
               v-if="item.productName && item.quantity && item.rate" 
               type="number" 
               suffix="₹"
               :disabled="isSpecialChargePercentage"
               v-model.number="item.specialCharge"
               label="Labour Charge in ₹">
             </v-text-field>
           </v-flex>
           <!-- End of Special Charge-->
          <v-flex xs12 sm6 md4>
            <v-select
              v-if="item.productName && item.quantity && item.rate"
              dense
              :items="godawnByBrand"
              label="Via Godawn"
              v-model="item.godawnBy"
            ></v-select>
          </v-flex>
          
          <v-flex xs12 sm6 md4  v-if="item.productName && item.quantity && item.rate">
              <v-select
                v-if="item.productName"
                :items="currentProdDrawers"
                :item-text="'text'"
                :item-value="'value'"
                v-model="item.drawerId"
                label="Select Drawer">
            </v-select>
          </v-flex>
          <v-flex xs12 sm3 md3 class="sub-desc">
            <v-textarea 
              v-if="item.productName && item.quantity && item.rate"
              background-color="grey darken-1" 
              color="black" 
              box 
              label="Description" v-model="item.subDescription"></v-textarea>
          </v-flex>
          <v-flex xs12 sm3 md3>
            <div v-for="(offer,index) in offerList" :key="index">
              <h3 class="red--text font-weight-bold">Offer : Buy {{offer.minQuantity}} Get {{offer.offerQuantity}} Free!</h3>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <!-- <v-card-actions>
      <v-btn color="blue darken-1" @click.native="close">Cancel</v-btn>
      <v-spacer></v-spacer>
      <v-btn class="grey darken-1" @click.native="close">Back</v-btn>
      <v-btn class="primary white--text" :disabled="!(item.productName && item.quantity && item.rate)" @click.native="save(false)">Save</v-btn>
      <v-btn color="success white--text" :disabled="!(item.productName && item.quantity && item.rate)" @click.native="save(true)">Save & Add Another item</v-btn>
    </v-card-actions> -->
  </v-card>
    <v-dialog v-model="scannerDialog" persistent max-width="800px">
         <v-card>
        <v-card-title class="primary white--text">
          <span class="headline">Scan Barcode of Product</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
             <section id="container" class="container">
                <label>
                    <span>Camera</span>
                    <select name="input-stream_constraints" id="deviceSelection">
                    </select>
                </label>
                 <div id="interactive" class="viewport"></div>
             </section>
          </v-container>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="scannerDialog = false">Cancel</v-btn>
        </v-card-actions>
         </v-card>
      </v-dialog>
      <v-dialog v-model="productReportDialog" persistent max-width="1000px">
        <v-card>
          <v-card-title class="primary white--text">
            <span class="headline">Product Report</span>
          </v-card-title>
          <v-card-text>
            <product-reports :product="selectedProduct" :isBuyer="isBuyer" :buyerId="buyer['.key']"/>
          </v-card-text>
       
         <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="productReportDialog = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </cotainer>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import { json } from "body-parser";

const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];

export default {
  props: {
    isBuyer : Boolean,
    firmSetting : Object,
    buyer: Object,
    selectedFirm: String,
    isEditItems : Boolean,
    gstInvoice : Boolean,
    allItems : Array,
    invoiceDate : String,
    editedItem: {
      type: Object,
      default: function() {
        return {
          productName: "",
          productId: "",
          HSN_code: "",
          taxableGST_rate: 0,
          rate: 0,
          unit: "",
          quantity: 1,
          basicPrice: 0,
          GSTValue: 0,
          totlePrice: 0,
          GST_type : "",
          productUnit : '',
          tradeDiscount : 0,
          specialCharge : 0,
          purity : 100,
          netWeight : 0,
          // tunch : '',
          brokerageRate : 0,
          drawerId : null,
        };
      }
    },
    godawn:String
  },
  data() {
    return {
      // isBuyer : null,
      productReportDialog : false,
      search:null,
      timeoutSearch:null,
      isTradePercentage:false,
      isSpecialChargePercentage:false,
      scannerDialog:false,
      // individualProdBrokerage : Boolean,
      tradeDiscountPercentage : null,
      specialChargePercentage : null,
      item: this.editedItem,
      products: [],
      availableProductUnit : this.units,
      selectedProduct: {},
      stepper: 1,
      isOpeningBalance: false,
      isStanderedPrice: false,
      addProductDialog: false,
      datepicker : false,
      snackbar : false,
      productChanged : false,
      duplicateError : null,
      timeout : 3000,
      GST_types: [
        {
          text: "Exempt",
          value: "EXEMPT"
        },
        {
          text: "Nil Rated",
          value: "NILL"
        },
        {
          text: "Taxable",
          value: "TAXABLE"
        },
        {
          text: "Non-GST",
          value: "OTHER"
        }
      ],
      currentProduct: {
        name: "",
        description: "",
        HSN_code: 0,
        GST_type: "",
        taxableGST_rate: 0,
        unit: "",
        quantity: 0,
        brand: "",
        openingDate : new Date().toISOString().substr(0, 10),
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        gstValue : 0,
        basicPrice : 0
      },
    };
  },
  components : {
    ProductReports: () => import('../../ProductReports/ProductReports.vue')
  },
  watch: {
    "godawn": {
      handler(newVal, oldVal) {
        if(!this.item.godawnBy)
        {
          this.item.godawnBy = newVal;
        }
      },
      deep: true
    },
    "item.productId": {
      handler(newVal, oldVal) {
        this.item.purity = 100;
      },
      deep: true
    },
    search(val){
      if(val.length > 9) {
        this.addProductByBarcode(val)
      }
    },
    editedItem(val) {
      this.item = this.editedItem;
      if(this.editedItem.productId) {        
        this.selectedProduct = this.products.filter(item => item['.key'] == this.editedItem.productId)[0];
        this.availableProductUnit = this.units;
      }
    },
    "item.rate": {
      handler(newVal, oldVal) {
        this.calculatePrices();
      },
      deep: true
    },
    "item.tradeDiscount": {
      handler(newVal, oldVal) {
        this.calculatePrices();
      },
      deep: true
    },
    "item.specialCharge": {
      handler(newVal, oldVal) {
        this.calculatePrices();
      },
      deep: true
    },
    "item.quantity": {
      handler(newVal, oldVal) {
        this.calculatePrices();
      },
      deep: true
    },
    "item.grossWeight": {
      handler(newVal, oldVal) {
        this.calculatePrices();
      },
      deep: true
    },
    "item.purity": {
      handler(newVal, oldVal) {
        this.calculatePrices();
      },
      deep: true
    },
    "item.unit": {
      handler(newVal, oldVal) {
       // this.productChange(this.selectedProduct);
        this.unitChange(newVal);
      },
      deep: true
    },
    "currentProduct.GST_type": {
      handler(newVal, oldVal) {
        if (newVal != "TAXABLE") {
          this.currentProduct.taxableGST_rate = 0;
        }
      },
      deep: true
    },
     "currentProduct.basicPrice": {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculateOpeningBalance();
        }
      },
      deep: true
    },
    "currentProduct.gstValue": {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculateOpeningBalance();
        }
      },
      deep: true
    }
  },
  created() {
    //this.item.purity = 100;
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    // this.$bindAsObject(
    //   'buyerById',
    //   this.$root.$firebaseRefs.buyer
    // );
    this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray(
      "productDrawers",
      this.$root.$firebaseRefs.productDrawer
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand","finYear"]),
    ...mapGlobalGetters({ units: "productUnit" }),
    currentProdDrawers(){
      if(this.selectedProduct) {
        return this.productDrawers.filter(item=>{
          return (!!item.items.find(i => i.product == this.selectedProduct['.key']))
        }).map(i => {return {text:i.name, value: i['.key']}})
      }
      return [];
    },
    productsByBrand() {
        return this.products.filter(
          item => (item["brand"] === this.selectedBrand  &&
          (!this.gstInvoice ? item.GST_type !='TAXABLE' : true) &&
          ((!!item.firm && this.selectedFirm ? item.firm == this.selectedFirm : false)) &&
          (item.isActive == undefined ? true : item.isActive)) 
          // && (item.openingDate ? (item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end) : true))
        );
    },
    offerList(){
      let offerItems = [];
      let date = new Date(this.invoiceDate).getTime();
      if(this.selectedProduct && this.selectedProduct.offers) {
        offerItems = this.selectedProduct.offers.filter((item)=>{
          return (item.startDate <= date && item.endDate >= date);
        })
      }
      return offerItems;
    },
    godawnByBrand() {
      return this.godawns
        .filter(item => {
          return (
            item["brand"] === this.selectedBrand 
          );
        })
        .map(item => {
          return {
            text: item["godawnName"],
            value: item[".key"]
          };
        });
    },
    getHeaders(){
       if(this.gstInvoice) {
          return [
          { text: "Name", sortable: false, value: "productName" , class: "font-weight-bold primary--text" },
          // { text: "Taxable Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" },
          { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" },
          { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" },
          { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" },
          { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" },
          { text: "GST value", sortable: false, value: "GSTValue", class: "font-weight-bold primary--text" },
          { text: "Special Charge", sortable: false, value: "specialCharge", class: "font-weight-bold primary--text" },
          { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" },
          { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text", },
          // { text: "CGST ", sortable: false, value: "CGST", class: "font-weight-bold primary--text" },
          // { text: "SGST ", sortable: false, value: "SGST", class: "font-weight-bold primary--text" },
          // { text: "IGST ", sortable: false, value: "IGST", class: "font-weight-bold primary--text" },
          { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" },
          { text: "", value: "name", sortable: false }
        ]
      }
      else {
        return [
          { text: "Name", sortable: false, value: "productName" , class: "font-weight-bold primary--text" },
          { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" },
          { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" },
          { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" },
          { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" },
          { text: "Special Charge", sortable: false, value: "specialCharge", class: "font-weight-bold primary--text" },
          { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" },
          { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text", },
          { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" },
          { text: "", value: "name", sortable: false }
        ]
      }
    },
    formTitle() {
      return this.editedIndex === -1 ? "Edit Grain item" : "New Grain item";
    }
  },

  methods: {
    openProductReport(){
      this.productReportDialog = true;
    },
    close() {
      this.$emit("closeAddItem",false);
      this.reset();
    },
    editItem(item) {
      this.reset();
       this.$emit("editItem",item,true);
    },
    deleteItem(item){
      this.reset();
      this.$emit("deleteItem",item);
    },
    productChange(val) {
      this.selectedProduct = val;
      // let buyer = this.buyerById[this.buyerId];
      // let isBuyer = buyer  ? true : false;
      this.item.productId = val[".key"];
      this.item.HSN_code = val["HSN_code"];
      this.item.taxableGST_rate = val["taxableGST_rate"];
      this.item.unit = val["unit"];
        // if(this.selectedProduct.unit == this.item.unit) {
        //   this.item.rate = this.isBuyer ? val["sellingPrice"] : val["purchasingPrice"]
        // }
      this.productChanged = true; 
      if(this.selectedProduct.unitsDeatilsAdded) {
        this.availableProductUnit = this.selectedProduct.unitsDetails.map((prod)=> { 
            return prod.unit 
        });
      } else {
        if(this.selectedProduct.unit == this.item.unit) {
          this.item.rate = this.isBuyer ? val["sellingPrice"] : val["purchasingPrice"]
        }
        if(this.isBuyer && this.buyer.category && this.selectedProduct.sellingPriceByCategories && this.selectedProduct.sellingPriceByCategories[this.buyer.category]) {
          this.item.rate = this.selectedProduct.sellingPriceByCategories[this.buyer.category]
        }
        this.availableProductUnit = this.units;
      }
      if(val.isSpecialChargePercentage && val.specialChargePercentage) {
        this.specialChargePercentage = Number.parseFloat(val.specialChargePercentage);
        this.isSpecialChargePercentage = true;
        this.calculateSpecialCharge();
      } else if(val.specialCharge) {
        this.item.specialCharge = Number.parseFloat(val.specialCharge);
      }
      this.productChanged = true; 
    },
    unitChange(selectedUnit){
       if(this.selectedProduct.unitsDeatilsAdded) {
        this.selectedProduct.unitsDetails.map((prod)=> { 
            if(prod['unit'] == selectedUnit) {
              let rate = this.isBuyer ? prod["sellingPrice"] : prod["purchasingPrice"];
              if(rate) {
                this.item.rate = rate;
              }
            }
        });
      } 
    },
    calculateTradeDiscount(){
      this.item.tradeDiscount = Number.parseFloat((this.tradeDiscountPercentage * this.item.rate * this.item.quantity)/100).toFixed(2);
    },
    calculateSpecialCharge(){
      if(this.isSpecialChargePercentage) {
        this.item.specialCharge = Number.parseFloat((this.specialChargePercentage * this.item.rate * this.item.quantity * this.item.netWeight)/100).toFixed(2);
      }
    },
    calculatePrices() {
      // if(this.isBuyer == null) {
      //     let buyer = this.buyerById[this.buyerId];
      //     this.isBuyer = buyer  ? true : false;
      // }
      // this.item.netWeight = ((this.item.quantity  * this.item.purity )/100)
      // this.item.netWeight = Number.parseFloat((this.item.quantity  * this.item.purity )/100).toFixed(2) 
      this.item.netWeight = Number.parseFloat(Number.parseFloat(this.item.grossWeight  * this.item.purity)/100).toFixed(3)     
      if(this.firmSetting && this.firmSetting.isRoundOff) {
        console.log("round")
        let basicPrice = (Number.parseFloat(
        this.item.rate * this.item.netWeight) - Number.parseFloat(this.item.tradeDiscount) + Number.parseFloat (this.item.specialCharge)).toFixed(2);
        this.item.basicPrice = Math.round(Number.parseFloat(basicPrice));
        let GSTValue = Number.parseFloat(
        this.item.basicPrice * (parseFloat(this.item.taxableGST_rate)/100)).toFixed(2);
        this.item.GSTValue = Math.round(Number.parseFloat(GSTValue));
        let totlePrice = Number.parseFloat(
        (Number.parseFloat(this.item.basicPrice) + Number.parseFloat(this.item.GSTValue))).toFixed(2);
        this.item.totlePrice = Math.round(Number.parseFloat(totlePrice));
      } else {
        this.item.basicPrice = (Number.parseFloat(
        this.item.rate * this.item.netWeight) - Number.parseFloat(this.item.tradeDiscount) + Number.parseFloat (this.item.specialCharge)).toFixed(2);
        this.item.GSTValue = Number.parseFloat(
        this.item.basicPrice * (parseFloat(this.item.taxableGST_rate)/100)).toFixed(2);
        this.item.totlePrice = Number.parseFloat(
        (Number.parseFloat(this.item.basicPrice) + Number.parseFloat(this.item.GSTValue))).toFixed(2);
      }
      this.calculateSpecialCharge();
      this.calculateTradeDiscount();
    },
    save(saveAndAdd) {
      // let buyer = this.buyerById[this.buyerId];
      // let isBuyer = buyer  ? true : false;
      // if(!this.isBuyer) {
      //   this.item.expiryDate = new Date(this.item.expiryDate).getTime(),
      //   this.item.manufacturingDate = new Date(this.item.manufacturingDate).getTime()
      // }
      let minQ = 0 ;
      if(this.offerList.length) {
        
        this.offerList.map((item)=>{
          if(item.minQuantity <= this.item.quantity && minQ <item.offerQuantity) {
            minQ = item.offerQuantity;
          }
        })
        
      }
      if(this.item.quantity > this.selectedProduct.quantity && this.isBuyer) {
        if((this.firmSetting && this.firmSetting.hideNegetiveStockAlert) || confirm("stock can go in negative - do you want to proceed ?")) {
          if(!this.isEditItems || (this.isEditItems && this.productChanged)) {
            this.item.productName = this.selectedProduct.name;
            this.item.GST_type = this.selectedProduct.GST_type;
            this.item.productUnit = this.selectedProduct.unit;
            this.item.availableQuantity = this.selectedProduct.quantity
          }
          if(minQ) {
              let clonedItem = {...this.item};
              clonedItem.quantity = minQ;
              clonedItem.basicPrice = 0;
              clonedItem.rate = 0;
              clonedItem.GSTValue = 0;
              clonedItem.totlePrice = 0;
              this.$emit('saveAddItem', clonedItem,false)
          }
          this.$emit('saveAddItem', this.item,saveAndAdd)
          this.reset()
        }
      } else {
        if(!this.isEditItems || (this.isEditItems && this.productChanged)) {
          this.item.productName = this.selectedProduct.name;
          this.item.GST_type = this.selectedProduct.GST_type;
          this.item.productUnit = this.selectedProduct.unit;
          this.item.availableQuantity = this.selectedProduct.quantity
        }
        if(minQ) {
            let clonedItem = {...this.item};
            clonedItem.quantity = minQ;
            clonedItem.basicPrice = 0;
            clonedItem.rate = 0;
            clonedItem.GSTValue = 0;
            clonedItem.totlePrice = 0;
            this.$emit('saveAddItem', clonedItem,false)
        }
        this.$emit('saveAddItem', this.item,saveAndAdd)
        this.reset()
      }
    },
    reset() {
      this.item = {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        GST_type : "",
        productUnit : '',
        totlePrice: 0,
        tradeDiscount : 0,
        grossWeight : 0,
        purity : 100,
        netWeight : 0,
        specialCharge : 0,
        //tunch : '',
        drawerId : null,
      };
      this.tradeDiscountPercentage = null;
      this.isTradePercentage = false;
      this.specialChargePercentage = null;
      this.isSpecialChargePercentage = false;
    },
    calculateOpeningBalance() {
      this.currentProduct.openingBalance = Number.parseFloat(this.currentProduct.basicPrice) + Number.parseFloat(this.currentProduct.gstValue);
    },
    scanItem(){
      this.scannerDialog = true;
      this.initQugga();
    },
    initQugga(){
    let selfVue = this;
          $(function() {
    var resultCollector = Quagga.ResultCollector.create({
        capture: true,
        capacity: 20,
        blacklist: [{
            code: "WIWV8ETQZ1", format: "code_93"
        }, {
            code: "EH3C-%GU23RK3", format: "code_93"
        }, {
            code: "O308SIHQOXN5SA/PJ", format: "code_93"
        }, {
            code: "DG7Q$TV8JQ/EN", format: "code_93"
        }, {
            code: "VOFD1DB5A.1F6QU", format: "code_93"
        }, {
            code: "4SO64P4X8 U4YUU1T-", format: "code_93"
        }],
        filter: function(codeResult) {
            // only store results which match this constraint
            // e.g.: codeResult
            return true;
        }
    });
    var App = {
        init: function() {
            var self = this;

            Quagga.init(this.state, function(err) {
                if (err) {
                    return self.handleError(err);
                }
                //Quagga.registerResultCollector(resultCollector);
                App.attachListeners();
                App.checkCapabilities();
                Quagga.start();
            });
        },
        handleError: function(err) {
            console.log(err);
        },
        checkCapabilities: function() {
            var track = Quagga.CameraAccess.getActiveTrack();
            var capabilities = {};
            if (typeof track.getCapabilities === 'function') {
                capabilities = track.getCapabilities();
            }
            this.applySettingsVisibility('zoom', capabilities.zoom);
            this.applySettingsVisibility('torch', capabilities.torch);
        },
        updateOptionsForMediaRange: function(node, range) {
            console.log('updateOptionsForMediaRange', node, range);
            var NUM_STEPS = 6;
            var stepSize = (range.max - range.min) / NUM_STEPS;
            var option;
            var value;
            while (node.firstChild) {
                node.removeChild(node.firstChild);
            }
            for (var i = 0; i <= NUM_STEPS; i++) {
                value = range.min + (stepSize * i);
                option = document.createElement('option');
                option.value = value;
                option.innerHTML = value;
                node.appendChild(option);
            }
        },
        applySettingsVisibility: function(setting, capability) {
            // depending on type of capability
            if (typeof capability === 'boolean') {
                var node = document.querySelector('input[name="settings_' + setting + '"]');
                if (node) {
                    node.parentNode.style.display = capability ? 'block' : 'none';
                }
                return;
            }
            if (window.MediaSettingsRange && capability instanceof window.MediaSettingsRange) {
                var node = document.querySelector('select[name="settings_' + setting + '"]');
                if (node) {
                    this.updateOptionsForMediaRange(node, capability);
                    node.parentNode.style.display = 'block';
                }
                return;
            }
        },
        initCameraSelection: function(){
            var streamLabel = Quagga.CameraAccess.getActiveStreamLabel();

            return Quagga.CameraAccess.enumerateVideoDevices()
            .then(function(devices) {
                function pruneText(text) {
                    return text.length > 30 ? text.substr(0, 30) : text;
                }
                var $deviceSelection = document.getElementById("deviceSelection");
                while ($deviceSelection.firstChild) {
                    $deviceSelection.removeChild($deviceSelection.firstChild);
                }
                devices.forEach(function(device) {
                    var $option = document.createElement("option");
                    $option.value = device.deviceId || device.id;
                    $option.appendChild(document.createTextNode(pruneText(device.label || device.deviceId || device.id)));
                    $option.selected = streamLabel === device.label;
                    $deviceSelection.appendChild($option);
                });
            });
        },
        attachListeners: function() {
            var self = this;

            self.initCameraSelection();
            $(".controls").on("click", "button.stop", function(e) {
                e.preventDefault();
                Quagga.stop();
                self._printCollectedResults();
            });

            $(".controls .reader-config-group").on("change", "input, select", function(e) {
                e.preventDefault();
                var $target = $(e.target),
                    value = $target.attr("type") === "checkbox" ? $target.prop("checked") : $target.val(),
                    name = $target.attr("name"),
                    state = self._convertNameToState(name);

                console.log("Value of "+ state + " changed to " + value);
                self.setState(state, value);
            });
        },
        _printCollectedResults: function() {
            var results = resultCollector.getResults(),
                $ul = $("#result_strip ul.collector");

            results.forEach(function(result) {
                var $li = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');

                $li.find("img").attr("src", result.frame);
                $li.find("h4.code").html(result.codeResult.code + " (" + result.codeResult.format + ")");
                $ul.prepend($li);
            });
        },
        _accessByPath: function(obj, path, val) {
            var parts = path.split('.'),
                depth = parts.length,
                setter = (typeof val !== "undefined") ? true : false;

            return parts.reduce(function(o, key, i) {
                if (setter && (i + 1) === depth) {
                    if (typeof o[key] === "object" && typeof val === "object") {
                        Object.assign(o[key], val);
                    } else {
                        o[key] = val;
                    }
                }
                return key in o ? o[key] : {};
            }, obj);
        },
        _convertNameToState: function(name) {
            return name.replace("_", ".").split("-").reduce(function(result, value) {
                return result + value.charAt(0).toUpperCase() + value.substring(1);
            });
        },
        detachListeners: function() {
            $(".controls").off("click", "button.stop");
            $(".controls .reader-config-group").off("change", "input, select");
        },
        applySetting: function(setting, value) {
            var track = Quagga.CameraAccess.getActiveTrack();
            if (track && typeof track.getCapabilities === 'function') {
                switch (setting) {
                case 'zoom':
                    return track.applyConstraints({advanced: [{zoom: parseFloat(value)}]});
                case 'torch':
                    return track.applyConstraints({advanced: [{torch: !!value}]});
                }
            }
        },
        setState: function(path, value) {
            var self = this;

            if (typeof self._accessByPath(self.inputMapper, path) === "function") {
                value = self._accessByPath(self.inputMapper, path)(value);
            }

            if (path.startsWith('settings.')) {
                var setting = path.substring(9);
                return self.applySetting(setting, value);
            }
            self._accessByPath(self.state, path, value);

            console.log(JSON.stringify(self.state));
            App.detachListeners();
            Quagga.stop();
            App.init();
        },
        inputMapper: {
            inputStream: {
                constraints: function(value){
                    if (/^(\d+)x(\d+)$/.test(value)) {
                        var values = value.split('x');
                        return {
                            width: {min: parseInt(values[0])},
                            height: {min: parseInt(values[1])}
                        };
                    }
                    return {
                        deviceId: value
                    };
                }
            },
            numOfWorkers: function(value) {
                return parseInt(value);
            },
            decoder: {
                readers: function(value) {
                    if (value === 'ean_extended') {
                        return [{
                            format: "ean_reader",
                            config: {
                                supplements: [
                                    'ean_5_reader', 'ean_2_reader'
                                ]
                            }
                        }];
                    }
                    return [{
                        format: value + "_reader",
                        config: {}
                    }];
                }
            }
        },
        state: {
            inputStream: {
                type : "LiveStream",
                constraints: {
                    width: {min: 640},
                    height: {min: 480},
                    facingMode: "environment",
                    aspectRatio: {min: 1, max: 2}
                }
            },
            locator: {
                patchSize: "medium",
                halfSample: true
            },
            numOfWorkers: 2,
            frequency: 10,
            decoder: {
                readers : [{
                    format: "ean_reader",
                    config: {}
                }]
            },
            locate: true
        },
        lastResult : null
    };

    App.init();

    Quagga.onProcessed(function(result) {
        var drawingCtx = Quagga.canvas.ctx.overlay,
            drawingCanvas = Quagga.canvas.dom.overlay;

        if (result) {
            if (result.boxes) {
                drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
                result.boxes.filter(function (box) {
                    return box !== result.box;
                }).forEach(function (box) {
                    Quagga.ImageDebug.drawPath(box, {x: 0, y: 1}, drawingCtx, {color: "green", lineWidth: 2});
                });
            }

            if (result.box) {
                Quagga.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {color: "#00F", lineWidth: 2});
            }

            if (result.codeResult && result.codeResult.code) {
                Quagga.ImageDebug.drawPath(result.line, {x: 'x', y: 'y'}, drawingCtx, {color: 'red', lineWidth: 3});
            }
        }
    });

    Quagga.onDetected(function(result) {
        var code = result.codeResult.code;
        console.log(code)
        Quagga.stop();
        selfVue.addProductByBarcode(code);
        // if (App.lastResult !== code) {
        //     App.lastResult = code;
        //     var $node = null, canvas = Quagga.canvas.dom.image;

        //     $node = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');
        //     $node.find("img").attr("src", canvas.toDataURL());
        //     $node.find("h4.code").html(code);
        //     $("#result_strip ul.thumbnails").prepend($node);
        // }
        });

    });

      },
      addProductByBarcode(barcode){
        let product = this.productsByBrand.filter(item => item.barcode == barcode)[0];
        let productName = this.productsByBrand.filter(item => item.name == barcode)[0];
        if(product) {
              clearInterval(this.timeoutSearch)
              this.productChange(product);
              this.item.quantity = 1;
              this.item.productName = product.name
              this.scannerDialog = false;
              this.search = ""
              this.save(true)
        } else if(productName) {
          clearInterval(this.timeoutSearch)
        } else {
          this.timeoutSearch = setTimeout(() => {
            this.search = ""
          }, 2000);
        }
      }
  }
};
</script>
<style>
  .sub-desc textarea {
    height: 30px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Quick/Invoice/AddItemGrain.vue